import React from 'react'
import Skeleton from 'react-loading-skeleton'

const CommentCardSkeleton = () => {
  return <Skeleton width={'100%'} height={127} />
}

export default CommentCardSkeleton
